<template>
  <div>
    <ChooseFamilyMemberDialog 
      v-if="showChooseFamilyMemberDialog" 
      :is-show-dialog="showChooseFamilyMemberDialog" 
      :shipping-address="shippingAddress"
      @close="$emit('closeFamilyMemberDialog')" 
      @searchOrCreatePatient="openSearchPatientDialog" 
    />
    <SearchPatientDialog 
      v-if="showSearchPatientDialog" 
      :is-show-dialog="showSearchPatientDialog" 
      :shipping-address="shippingAddress"
      :shipping-address-obj="shippingAddressObj"
      @close="showSearchPatientDialog = false" 
      @openChooseFamilyMemberDialog="openChooseFamilyMemberDialog"
      @openUpdateAddressDialog="openUpdateAddressDialog"
    />
    <ConfirmUpdateAddressDialog 
      v-if="showUpdateAddressDialog" 
      :is-show-dialog="showUpdateAddressDialog" 
      :patient="patientNeedUpdateAddress"
      :shipping-address="shippingAddress"
      :shipping-address-obj="shippingAddressObj"
      @close="showUpdateAddressDialog = false"
      @openUpdateAddressDialog="openUpdateAddressDialog"
      @openChooseFamilyMemberDialog="openChooseFamilyMemberDialog"
      @openSearchPatientDialog="openSearchPatientDialog"
    />
  </div>
</template>

<script>
import ChooseFamilyMemberDialog from "./choose-family-member-dialog/index.vue";
import SearchPatientDialog from "./SearchPatientDialog.vue";
import ConfirmUpdateAddressDialog from "./ConfirmUpdateAddressDialog.vue";
import { mapState } from "vuex";

export default {
  emits: ['openChooseFamilyMemberDialog', 'closeFamilyMemberDialog'],
  components: {
    ChooseFamilyMemberDialog,
    SearchPatientDialog,
    ConfirmUpdateAddressDialog,
  },
  props: {
    isShowDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showChooseFamilyMemberDialog: this.isShowDialog,
      showSearchPatientDialog: false,
      showUpdateAddressDialog: false,
      patientNeedUpdateAddress: {},
    }
  },
  computed: {
    ...mapState("orderTest/familyDiscount", ["familyMembers", "familyDiscountOrders"]),
    ...mapState("orderTest/order", ["patient"]),
    shippingAddressObj() {
      let { streetAddress, city, state, zipcode, country } = this.patient;
      return { streetAddress, city, state, zipcode, country };
    },
    shippingAddress() {
      return Object.values(this.shippingAddressObj).filter(Boolean).join(", ");
    },
  },
  watch: {
    isShowDialog(newVal) {
      this.showChooseFamilyMemberDialog = newVal;
    }
  },
  methods: {
    openSearchPatientDialog() {
      this.$emit('closeFamilyMemberDialog');
      this.showSearchPatientDialog = true;
      this.showUpdateAddressDialog = false;
    },
    openUpdateAddressDialog(patientObj) {
      this.patientNeedUpdateAddress = patientObj;
      this.showUpdateAddressDialog = true;
      this.showSearchPatientDialog = false;
      // this.showChooseFamilyMemberDialog = false;
    },
    openChooseFamilyMemberDialog() {
      this.showSearchPatientDialog = false;
      this.showUpdateAddressDialog = false;
      this.$emit('openChooseFamilyMemberDialog');
    }

  }
}
</script>

<style scoped>

</style>